import { EventAssociatedModel, EventFeed } from '~/types/adamTypes';
export const useAppEventFeed = async (
  type: EventFeed,
  contentId: string = null,
  eventData: any = {}
): Promise<void> => {
  const { createEvent } = useAppEvent(EventAssociatedModel.Feed, contentId);

  const shouldIncludeLevelOfEducation: boolean = false;

  await createEvent(type, eventData, shouldIncludeLevelOfEducation);
};
